// import { Download } from "lucide-react";

const CTA = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-teal-400 to-blue-500">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
          Download Sera on Google Play Store
        </h2>
        <p className="text-xl text-white/90 mb-8">
          Get Sera now and start batching notifications for a distraction-free, focused experience!
        </p>
            <div className="flex justify-center">
              <button className="group hover:scale-110 transition-all duration-300 ease-out p-3 rounded-2xl bg-gradient-to-r from-teal-400 to-blue-500 hover:from-teal-300 hover:to-blue-400 shadow-xl hover:shadow-2xl">
                <img 
                  src="/GetItOnGooglePlay_Badge_Web_color_English.png" 
                  alt="Get it on Google Play" 
                  className="h-14 w-auto rounded-xl group-hover:drop-shadow-[0_20px_40px_rgba(20,184,166,0.6)] group-hover:drop-shadow-[0_10px_25px_rgba(59,130,246,0.5)] group-hover:brightness-110 transition-all duration-300"
                />
              </button>
            </div>
      </div>
    </section>
  );
};

export default CTA;
